import React from "react";
import { GenericValueInput } from "components/Global/Fields";
import { ValueTypes } from "pages/refiAnalysis/supervised/constants";

import { FilterHeader } from "..";
import "./minMaxInputFilterStyles.css";

const MinMaxInputFilter = ({
  title = "MinMaxInputFilterHeader",
  valueType = ValueTypes.currency,
  minError,
  setMinError = () => { },
  minLabel = "",
  minErrorMessage = "",
  minAmount = 0,
  minAmountDefault = 0,
  setMinAmount = () => { },
  maxError,
  setMaxError = () => { },
  maxLabel = "",
  maxErrorMessage = "",
  maxAmount = 0,
  maxAmountDefault = 0,
  setMaxAmount = () => { },
  setIsActive = () => {},
  onBlur
}) => {
  const resetAmounts = () => {
    setMinAmount(minAmountDefault);
    setMaxAmount(maxAmountDefault);
    setMinError(false);
    setMaxError(false);
    setIsActive(false);
  };

  const determineMinMaxError = minAmount > maxAmount;

  return (
    <div className="filter-panel-filters-wrapper">
      <FilterHeader title={title} onReset={() => resetAmounts()} />
      <div className="filter-panel-filters-content-wrapper">
        <div>
          <GenericValueInput
            isMin
            debounceTime={3000}
            valueType={valueType}
            label={minLabel}
            name={`dsFilter${minLabel.trim()}`}
            value={minAmount}
            defaultValue={minAmountDefault}
            setAmount={setMinAmount}
            error={minError}
            minMaxError={determineMinMaxError}
            setError={setMinError}
            errorMessage={determineMinMaxError ? `${minLabel} can\'t be greater than ${maxLabel.toLowerCase()}` : minErrorMessage}
            onBlur={onBlur}
          />
        </div>
        <div>
          <GenericValueInput
            debounceTime={3000}
            valueType={valueType}
            label={maxLabel}
            name={`dsFilter${maxLabel.trim()}`}
            value={maxAmount}
            defaultValue={maxAmountDefault}
            setAmount={setMaxAmount}
            error={maxError}
            minMaxError={determineMinMaxError}
            setError={setMaxError}
            errorMessage={determineMinMaxError ? `${maxLabel} can\'t be less than ${minLabel.toLowerCase()}` : maxErrorMessage}
            onBlur={onBlur}
          />
        </div>
      </div>
    </div>
  );
};

export default MinMaxInputFilter;
